/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agents_P2Inputs */

const en_home_agents_p2 = /** @type {(inputs: Home_Agents_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Claude or any MCP client to CADCraft and ask it to draft a plate, dimension a part or convert a folder of DWG files. Because the agent can query entities and render screenshots, it checks its own work instead of guessing.`)
};

/**
* | output |
* | --- |
* | "Connect Claude or any MCP client to CADCraft and ask it to draft a plate, dimension a part or convert a folder of DWG files. Because the agent can query enti..." |
*
* @param {Home_Agents_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_agents_p2 = /** @type {((inputs?: Home_Agents_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agents_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_agents_p2(inputs)
});
export { home_agents_p2 as "home.agents.p2" }